// src/app/pages/pages-routing.module.ts
import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import { DashboardComponent } from './dashboard/dashboard.component';
import { UserComponent } from './user/user.component';
import { BoardComponent } from './board/board.component';
import { CabinetComponent } from './cabinet/cabinet.component';
import { LocationComponent } from './location/location.component';
import { LocationDashboardComponent } from './locationDashboard/locationDashboard.component';
import { SalesRepComponent } from './salesrep/salesrep.component';
import { ActivationComponent } from './activation/activation.component';
import { BoardReadComponent } from './boardRead/boardRead.component';
import { GameComponent } from './game/game.component';
import { BoardTypeComponent } from './boardType/boardType.component';
import { FileUploadComponent } from './file-upload/file-upload.component';
import { PrinterTypeComponent } from './printerType/printerType.component';
import { MonitorTypeComponent } from './monitorType/monitorType.component';
import { BvTypeComponent } from './bvType/bvType.component';
import { HarnessTypeComponent } from './HarnessType/harnessType.component';
import { CabinetTypeComponent } from './cabinetType/cabinetType.component';
import { BoardStatsComponent } from './boardStats/boardStats.component';
import { BoardStatsByIdComponent } from './boardStatsById/boardStatsById.component';
import { BoardStatsDashboardComponent } from './boardStatDashBoard/boardStatsDashBoard.component';
import { BoardStatsReportComponent } from './board-stats-report/board-stats-report.component';
import { CollectionSummaryComponent } from './collectionSummary/collection-summary.component';
import { SalesBlankComponent } from './sales-blank/sales-blank.component';
import { PendingCollectionsComponent } from './pending-collections/pending-collections.component';
import { FusionConnectComponent } from './fusion-connect/fusion-connect.component';
import { FusionConnectStatsComponent } from './fusion-connect-stats/fusion-connect-stats.component';
import { DashboardSelectorComponent } from './dashboard-selector/dashboard-selector.component';
import { InternalDashboardComponent } from './internal-dashboard/internal-dashboard.component';
import { InventoryComponent } from './inventory/inventory.component';

const routes: Routes = [
  { path: '', component: DashboardComponent },
  { path: 'dashboard-selector', component: DashboardSelectorComponent },
  { path: 'internal-dashboard', component: InternalDashboardComponent },
  { path: 'internal-dashboard/:view', component: InternalDashboardComponent },
  { path: 'inventory', component: InventoryComponent },

  { path: 'users', component: UserComponent },
  { path: 'boards', component: BoardComponent },
  { path: 'cabinets', component: CabinetComponent },

  // keep ONE of these; pick the correct component for /locations
  { path: 'locations', component: LocationComponent },
  // { path: 'locations-dashboard', component: LocationDashboardComponent }, // use different path if you need this too

  { path: 'salesreps', component: SalesRepComponent },
  { path: 'salesreps/users', component: UserComponent },
  { path: 'activations', component: ActivationComponent },
  { path: 'boardReads', component: BoardReadComponent },
  { path: 'games', component: GameComponent },
  { path: 'boardTypes', component: BoardTypeComponent },
  { path: 'printerTypes', component: PrinterTypeComponent },
  { path: 'monitorTypes', component: MonitorTypeComponent },
  { path: 'bvTypes', component: BvTypeComponent },
  { path: 'harnessTypes', component: HarnessTypeComponent },
  { path: 'cabinetTypes', component: CabinetTypeComponent },

  { path: 'boardStats/:assetTag', component: BoardStatsByIdComponent },

  // keep ONE default boardStats route
  { path: 'boardStats', component: BoardStatsComponent },
  // { path: 'boardStatsDashboard', component: BoardStatsDashboardComponent }, // different path if needed

  { path: 'boardUpload', component: FileUploadComponent },
  { path: 'reports', component: BoardStatsReportComponent },
  { path: 'collectionSummary', component: CollectionSummaryComponent },
  { path: 'sales-blank', component: SalesBlankComponent },
  { path: 'pending-collections', component: PendingCollectionsComponent },

  { path: 'fusion-connect', component: FusionConnectComponent },
  { path: 'fusion-connect-stats', component: FusionConnectStatsComponent },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class PagesRoutingModule {}
